'use strict';

//=include  ../MetricsTracker/home/metrics.js
//=include  ../MetricsTracker/footer/metrics.js

import HomeTracker from '../MetricsTracker/home/metrics';
import FooterTracker from '../MetricsTracker/footer/metrics';
import GlobalUtil from '../utils/pricetravel/shared/globalUtil';
import { StorageService } from '../vue/services/StorageService'
window.app.controller('controller', controller);

controller.$inject = ["$scope", "$http", "$timeout", "$location", "$rootScope", "localStorageService"];

function controller($scope, $http, $timeout, $location, $rootScope, localStorageService) {
    let vm = this;
    let __modal = "";
    let setting = window.__pt.settings;
    let culture = window.__pt.culture;
    let fn = window.__pt.fn || {};
    let tracker = new HomeTracker();
    let trackerFooter = new FooterTracker();
    let lang = window.__pt.ln;
    let _user = window.__pt.user || null;
    vm.collectionHotel = window.__pt.collectionHotel;
    vm.collectionPromotion = window.__pt.collectionPromotion;
    vm.collectionVacation = window.__pt.collectionVacation;
    vm.culture = window.__pt.cultureData;
    let _globalUtil = new GlobalUtil();
    vm.history = [];
    vm.viewed = [0, 1, 2];
    let config = window.__pt.settings.site;
    vm.isLogin = false;
    vm.responsePayment = {
        fixedPayments: [],
        monthInterestFree: [],
        loading: true
    };

    vm.bannerTabs = {
        hotel: 'hotel',
        flight: 'flight',
        package: 'package',
        disney: 'disney'
    };

    vm.collapseHome = {
        hotel: false,
        fligth: false,
        package: false,
        home: false,
        homeabout: false

    }

    vm.currentTab = vm.bannerTabs.hotel;

    vm.onLoadPayment = (modal, btnTitle, btnText) => {
        __modal = modal;
        vm.showModal(__modal, btnTitle, btnText);
        onSearchPaymentMethod();
    }

    vm.showModal = (modal, btnTitle, btnText) => {
        $(`#${modal}`).modal("show");

        if (modal == "modal-payform" || modal == "modal-contact") {
            tracker.selectContent(btnTitle, btnText);
        }
    }

    vm.onClosed = (modal) => {
        $(`#${modal}`).modal("hide");
    }


    vm.showService = (services) => {
        const path = vm.currentTab;
        return services.indexOf(path) != -1;
    }

    vm.handleTab = (selectedTab, url) => {

        //  vm.currentTab = selectedTab;
        if (selectedTab === vm.bannerTabs.disney) {
            window.open(url, "_blank");
        } else {
            vm.currentTab = selectedTab;
            onChangePath();
        }

        //TODO probar primero  onChangePath();
    }

    vm.sendContentFooter = (title) => {
        trackerFooter.clickLink(`footer :: ${title}`);
    }

    vm.selectDestination = (item) => {
        let bookerValuesEvent = "";
        let currentTabHo = getService();
        if (currentTabHo == vm.bannerTabs.flight || item.origin == "V") {
            bookerValuesEvent = setting.bookerValuesEventFlight;
        } else if (currentTabHo == vm.bannerTabs.hotel && (item.origin != "P" && item.origin != "V")) {
            bookerValuesEvent = setting.bookerValuesEvent;
        } else {
            bookerValuesEvent = setting.bookerValuesEventPackage;
        }
        if (currentTabHo == vm.bannerTabs.hotel) {
            if (item.origin != "H") {
                tracker.userInteraction(item.name);
                let paxesData = item.origin == "V" ? MapPaxToUrl(item.data.paxes) : MapPaxToUrlPackages(item.data.paxes);
                item.checkIn = new Date(item.checkIn);
                item.checkOut = new Date(item.checkOut);
                let data = {
                };
                let valuesDefaults = {};
                if (item.origin == "V") {
                    data = {
                        startingFromAirport: item.data.place_selected.code,
                        returningFromAirport: item.data.place_selected_to.code,
                        startingFromDateTime: fn.formatDate(item.checkIn, setting.formatDate),
                        returningFromDateTime: fn.formatDate(item.checkOut, setting.formatDate),
                        tripMode: +item.data.mode,
                        mode: +item.data.mode
                    }
                } else if (item.origin == "P") {
                    data = {
                        startingFromDateTime: fn.formatDate(item.checkIn, setting.formatDate),
                        returningFromDateTime: fn.formatDate(item.checkOut, setting.formatDate),
                        CheckIn: fn.formatDate(item.checkIn, setting.formatDate),
                        CheckOut: fn.formatDate(item.checkOut, setting.formatDate),
                        startingFromAirport: item.data.place_selected.placeCode,
                        returningFromAirport: item.data.place_selected_to.placeCode,
                        startingPlaceId: item.data.place_selected.placeId,
                        returningPlaceId: item.data.place_selected_to.placeId
                    }
                }
                data = { ...data, ...paxesData, ...valuesDefaults };
                var path = item.origin == "V" ? config.pathFlight : config.pathPackages;
                var form = document.createElement("form");
                form.setAttribute("method", "get");
                form.setAttribute("action", `${path}`);
                for (var key in data) {
                    if (data[key]) {
                        var hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", key);
                        hiddenField.setAttribute("value", data[key]);

                        form.appendChild(hiddenField);
                    }
                }
                $("#loader-page").removeClass("d-none");
                document.body.appendChild(form);
                form.submit();
            }
        }
        if (currentTabHo == vm.bannerTabs.hotel && item.origin == "H"){
            if (_globalUtil.getIsArray(item.box.pax)) {
                item.box.pax =  _globalUtil.convertPaxesData(item.box.pax);
            }
            tracker.selectRecentSearch(item);
            tracker.userInteraction(item.name);
            $rootScope.$broadcast(bookerValuesEvent, item);
        }
        if ((currentTabHo == vm.bannerTabs.flight && item.origin == "V") || (currentTabHo == vm.bannerTabs.package && item.origin == "P")) {
            tracker.selectRecentSearch(item);
            tracker.userInteraction(item.name);
            $rootScope.$broadcast(bookerValuesEvent, item);
        }
    }

    function MapPaxToUrlPackages(pax) {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let infants = 0;
        let agekids = [];
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];
            let position = i + 1;

            paxesKeys[`room${position}.adults`] = room.adults;
            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                if (childrenRoom.year > 5) {
                    kids += 1;
                } else {
                    infants += 1;
                }
            }
            paxesKeys[`room${position}.kids`] = childrens;
            paxesKeys[`room${position}.agekids`] = childreJoin.join(",");

        }
        paxesKeys[`rooms`] = rooms;
        paxesKeys[`adults`] = adults;
        paxesKeys[`infants`] = infants;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");


        return paxesKeys;
    }

    function MapPaxToUrl(pax) {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let infants = 0;
        let agekids = [];
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];
            let position = i + 1;

            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                kids += 1;
            }

        }
        paxesKeys[`adults`] = adults;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");


        return paxesKeys;
    }

    vm.onScreenCards = (item) => {
        if (vm.viewed.includes(item)) return;

        switch (item) {
            case 0:
                tracker.userViewPromotions(vm.collectionPromotion);
                break;
            case 1:
                tracker.userViewPromotions(vm.collectionHotel);
                break;
            case 2:
                tracker.userViewPromotions(vm.collectionVacation);
                break;

        }

        vm.viewed.push(item);
    };

    vm.selectPromotion = (index, listName) => {
        tracker.userSelectPromotion(vm[listName], vm[listName].cards[index]);
    }

    function onSearchPaymentMethod() {
        if (vm.responsePayment.fixedPayments.length || vm.responsePayment.monthInterestFree.length) { return; }
        let params = {
            channel: setting.site.channel,
            language: vm.culture.internalCultureCode,
            currency: vm.culture.currency
        }
        $http.get(setting.site.endPoints.paymentMethodUrl, { params: params }).then(onSuccessPaymentMethods, onError)

    }
    function onSuccessPaymentMethods(response) {
        const data = response.data || [];
        const monthInterestFree = data.monthInterestFree ? data.monthInterestFree.options : [];
        const groupedPayments = monthInterestFree.reduce((groups, item) => {
            const maxMonths = Math.max(...item.paymentPlans);
            if (!groups[maxMonths]) {
                groups[maxMonths] = [];
            }
            groups[maxMonths].push(item);
            return groups;
        }, {});
        const sortedEntries = Object.entries(groupedPayments).sort(([keyA], [keyB]) => Number(keyB) - Number(keyA));
        const paymentMethods = {
            fixedPayments: data.fixedPayments
                .map(fixedPayments => fixedPayments.options)
                .reduce((prev, curr) => prev.concat(curr), []),
            monthInterestFree: sortedEntries,
            quotasPayments: data.quotasPayments ? data.quotasPayments.options : [],
            otherPayments: data.otherPayments ? data.otherPayments.options : [],
            loading: false,
            maxmsi: data.monthInterestFree ? data.monthInterestFree.title : ""
        };
        vm.responsePayment = paymentMethods;
    }

    function onError(response) {
        console.log(response)
    }

    /**** Private ****/


    function getService() {
        let path = location.pathname.toLowerCase();
        let page = '';
        path = path.replace(`/${culture.cultureCode}`, "");
        const Airlines = "aeromexico,aircanada,airfrance,avianca,boletosaereos,clicair,continental,copa,iberia,jetblue,jetsmart,latam,satena,united,vivaaerobus,volaris,wingo";
        const airlinesList = Airlines.split(',');
        const getSecondSegment = (path) => {
            const segments = path.split('/').filter(s => s.trim() !== "");
            return segments.length > 0 ? `/${segments[0]}` : "/";
        };
        const secondSegmentPath = getSecondSegment(path);
        switch (secondSegmentPath) {
            case '/':
                page = config.siteName === "tiquetesbaratos" ? vm.bannerTabs.flight : vm.bannerTabs.hotel;
                break;
            case '/hoteles':
            case '/hotels':
                page = vm.bannerTabs.hotel;
                break;
            case '/vuelos':
            case '/flights':
                page = vm.bannerTabs.flight;
                break;
            case '/paquetes':
            case '/packages':
                page = vm.bannerTabs.package;
                break;
            case '/tiquetes':
                page = vm.bannerTabs.flight;
                break;
            default:
                const segments = path.split('/').filter(s => s.trim() !== "");
                if (segments.length > 0) {
                    const lastSegment = segments[segments.length - 1];
                    const baseSegment = lastSegment.split('-')[0];
                    if (airlinesList.includes(baseSegment)) {
                        page = vm.bannerTabs.flight;
                    } else {
                        page = config.siteName === "tiquetesbaratos" ? vm.bannerTabs.flight : vm.bannerTabs.hotel;
                    }
                } else {
                    page = config.siteName === "tiquetesbaratos" ? vm.bannerTabs.flight : vm.bannerTabs.hotel;
                }
                break;
        }
        return page;
    }

    function getPathCurrent(tab) {
        let page = '';

        switch (tab) {
            case vm.bannerTabs.hotel:
                page = '/';
                break;

            case vm.bannerTabs.hotel:
                page = '/hoteles';
                break;

            case vm.bannerTabs.hotel:
                page = '/hotels';
                break;

            case vm.bannerTabs.fligth:
                page = '/vuelos';
                break;

            case vm.bannerTabs.fligth:
                page = '/flights';
                break;

            case vm.bannerTabs.package:
                page = '/paquetes';
                break;

            case vm.bannerTabs.package:
                page = '/packages';
                break;
        }

        return page;
    }

    function onChangePath() {
        let path = getPathCurrent(vm.currentTab);
    }

    function init() {
           if (_user && _user.firebaseId) {
            vm.isLogin = true;
        } else {
            vm.isLogin = false;
        }
        caruosel();
        vm.currentTab = getService();
        onChangePath();
        if(!window.__pt.settings.rb){
            onSearchPaymentMethod();
        }
        getHistory(vm.currentTab);

        $('.promotion-element').on('click', (evt) => {
            let index = (+evt.currentTarget.name) - 1;
            tracker.userSelectPromotion(vm['collectionPromotion'], vm['collectionPromotion'].cards[index]);
        });

        const waitToCheckViewport = setTimeout(() => {
            vm.viewed = [];
            clearTimeout(waitToCheckViewport);
        }, 500);
    }

    function getHistory(current) {
        try {
            let recentDestination = "";
            if (current == vm.bannerTabs.flight) {
                recentDestination = setting.recentDestinationsFlight;
            } else if (current == vm.bannerTabs.hotel) {
                recentDestination = setting.recentDestinations;
            } else if (current == vm.bannerTabs.package) {
                recentDestination = setting.recentDestinationsPackage;
            } else {
                recentDestination = "";
            }
  
            vm.history = StorageService.get(recentDestination) || [];
            if (current == vm.bannerTabs.hotel) {

                let banIsComplete = false;
                let indexPosition = 0;
                let historyCopy = [];
                if (vm.history.length > 0) {
                    vm.history = vm.history.filter(item => item.hasOwnProperty('icon'))
                }
                while (vm.history.length <= 4 && !banIsComplete) {
                    let recentFlights = StorageService.get(setting.recentDestinationsFlight) || [];//vuelos
                    let recentsPackages = StorageService.get(setting.recentDestinationsPackage) || [];//paquetes
                    if (recentFlights.length > 0 && vm.history.length < 4) {
                        if (recentFlights[indexPosition] && recentFlights.every(i => i.hasOwnProperty('icon'))) {
                            recentFlights[indexPosition].name = recentFlights[indexPosition].data.place_selected_to.displayText.replace(recentFlights[indexPosition].data.place_selected_to.code, '').split(',')[0];
                            recentFlights[indexPosition].image = config.cloudCdn + "/assets/img/80x105_aviones_" + ((indexPosition >= 3 ? 0 : indexPosition) + 1).toString() + ".jpg";
                            recentFlights[indexPosition].title = lang[recentFlights[indexPosition].data.mode ? `flight_round_${setting.site.siteName}` : `flight_one_way_${setting.site.siteName}`];
                            vm.history.push(recentFlights[indexPosition]);
                        }
                    }
                    if (recentsPackages.length > 0 && vm.history.length < 4) {
                        if (recentsPackages[indexPosition] && recentsPackages.every(i => i.hasOwnProperty('icon'))) {
                            recentsPackages[indexPosition].title = lang.package_lang;
                            recentsPackages[indexPosition].image = config.cloudCdn + "/assets/img/Paquete_photo_home.jpg";
                            vm.history.push(recentsPackages[indexPosition]);
                        }
                    }
                    if (recentsPackages.length == 0 && recentFlights.length == 0) {
                        banIsComplete = true;
                    }
                    if (historyCopy.length != vm.history.length) {

                    } else {
                        banIsComplete = true;
                    }
                    indexPosition++;
                    historyCopy = vm.history;
                }
                vm.history = vm.history.map((item) => {
                    if (item.hasOwnProperty('icon')) {
                        item.adults = _globalUtil.getIsArray(item.box.pax)
                            ? item.box.pax.reduce((count, pax) => count + pax.adults, 0)
                            : item.box.pax.adults;
                
                        item.kids = _globalUtil.getIsArray(item.box.pax)
                            ? item.box.pax.reduce((count, pax) => count + pax.children.length, 0)
                            : item.box.pax.children.length;
                
                        item.checkin = fn.getDate(item.box.checkIn).toLocaleString(setting.site.culture, { month: 'short', day: 'numeric' });
                        item.checkout = fn.getDate(item.box.checkOut).toLocaleString(setting.site.culture, { month: 'short', day: 'numeric' });
                        item.name = item.name
                            ? item.name
                            : item.place.displayText.split(',').length > 0
                                ? item.place.displayText.split(',')[0]
                                : item.place.displayText.length > 32
                                    ? item.place.displayText.substring(0, 32) + '...'
                                    : item.place.displayText;
                        item.default = `${config.cloudCdn}/assets/recent-search-imgs/${item.origin != 'H' ? 'iatas' : 'places'}/${item.IdG}.jpg`;
                    }
                    return item;
                });
            } else if (current == vm.bannerTabs.flight) {

                if (vm.history.length > 0) {
                    vm.history = vm.history.filter(item => {
                        let now = new Date();
                        let checkIn = new Date(item.data.checkIn);
                        return (item.hasOwnProperty('data') && checkIn > now);
                    })
                }
               
                vm.history = vm.history.map((item,index) => {
                    item.checkIn = new Date(item.checkIn).toLocaleDateString(setting.site.culture, { day: '2-digit', month: 'short', year: 'numeric' });
                    item.checkOut = new Date(item.checkOut).toLocaleDateString(setting.site.culture, { day: '2-digit', month: 'short', year: 'numeric' });
                    item.name = item.data.place_selected_to.displayText.replace(item.data.place_selected_to.code, '').split(',').length > 0 ? item.data.place_selected_to.displayText.replace(item.data.place_selected_to.code, '').split(',')[0] : item.data.place_selected_to.displayText;
                    item.image = `${config.cloudCdn}/assets/img/80x105_aviones_${((index >= 3 ? 0 : index ) + 1)}.jpg`;
                    item.title = lang[item.data.mode ? `flight_round_${setting.site.siteName}` : `flight_one_way_${setting.site.siteName}`];
                    item.default = `${config.cloudCdn}/assets/recent-search-imgs/${item.origin != 'H' ? 'iatas' : 'places'}/${item.IdG}.jpg`;
                    item.adults = _globalUtil.getIsArray(item.box.pax)
                    ? item.box.pax.reduce((count, pax) => count + pax.adults, 0)
                    : item.box.pax.adults;
        
                    item.kids = _globalUtil.getIsArray(item.box.pax)
                        ? item.box.pax.reduce((count, pax) => count + pax.children.length, 0)
                        : item.box.pax.children.length;
                    return item;
                });
            } else if (current == vm.bannerTabs.package) {
                if (vm.history.length > 0) {
                    vm.history = vm.history.filter(item => {
                        let now = new Date();
                        let checkIn = new Date(item.data.checkIn);
                        return (item.hasOwnProperty('data') && checkIn > now);
                    })
                }
               
                vm.history = vm.history.map((item,index) => {
                    item.checkIn = fn.getDate(item.checkIn).toLocaleString(setting.site.culture, { month: 'short', day: 'numeric' });
                    item.checkOut = fn.getDate(item.checkOut).toLocaleString(setting.site.culture, { month: 'short', day: 'numeric' });
                    item.name = item.data.place_name_to.split(',').length > 0 ? item.data.place_name_to.split(',')[0] : item.data.place_name_to;
                    item.title = lang.package_lang;
                    item.image = config.cloudCdn + "/assets/img/Paquete_photo_home.jpg";
                    item.default = `${config.cloudCdn}/assets/recent-search-imgs/${item.origin != 'H' ? 'iatas' : 'places'}/${item.IdG}.jpg`;
                    item.adults = _globalUtil.getIsArray(item.box.pax)
                    ? item.box.pax.reduce((count, pax) => count + pax.adults, 0)
                    : item.box.pax.adults;
        
                    item.kids = _globalUtil.getIsArray(item.box.pax)
                        ? item.box.pax.reduce((count, pax) => count + pax.children.length, 0)
                        : item.box.pax.children.length;
                    return item;
                });
            }
        } catch (e) {
            console.log(e)
        }
        
    }

    function caruosel() {

        let options = {
            dots: false,
            infinite: false,
            speed: 300,
            initialSlide: 0,
            centerMode: false,
            variableWidth: false,
            lazyLoad: 'ondemand',
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 432,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        slickOptionsFire(options, "#carousel-promotion");
        slickOptionsFire(options, "#carousel-hotels");
        slickOptionsFire(options, "#carousel-vacation");
        let optionsSeo = {
            dots: false,
            infinite: false,
            speed: 300,
            initialSlide: 0,
            centerMode: false,
            variableWidth: false,
            lazyLoad: 'ondemand',
            slidesToShow: 6,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 432,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        slickOptionsFire(optionsSeo, "#carousel-seo-home");

    }

    function slickOptionsFire(options, div) {
        if ($(div).length == 0) {
            return;
        }
        var triggerAtY = $(div).offset().top - $(window).outerHeight();
        if (triggerAtY < $(window).scrollTop()) {
            $(div).slick(options);
            $(div).removeClass("visibility-none")
            return;
        }
        $(window).scroll(function (event) {
            if (triggerAtY > $(window).scrollTop()) {
                return;
            }
            $(div).slick(options);
            $(div).removeClass("visibility-none")
            $(this).off(event);
        });
    }

    

    init();

}
